import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.appointments-timetable': {
         showWeekends: 'Pokazuj weekendy',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.appointments-timetable'
);
